module.exports = __webpack_public_path__ + "img/our2.265a749c.svg";